import {GTDStage, Hub} from 'yougile-model'

const getStage = (task: Hub): GTDStage => task.data?.gtd?.state?.stage

export const sortByDoneCompleted = (tasks: Hub[]): Hub[] => {
  return tasks.sort((a, b) => {
    const isADone = getStage(a) !== 'done'
    const isBDone = getStage(b) !== 'done'

    if ((isADone && isBDone) || (!isADone && !isBDone)) {
      return 0
    }

    if (isADone) {
      return 1
    }

    return -1
  })
}

export const sortByDoneUnfulfilled = (tasks: Hub[]): Hub[] => {
  return tasks.sort((a, b) => {
    const isADone = getStage(a) === 'done'
    const isBDone = getStage(b) === 'done'

    if ((isADone && isBDone) || (!isADone && !isBDone)) {
      return 0
    }

    if (isADone) {
      return 1
    }

    return -1
  })
}
